import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@heroui/react";
import { useSearchParams } from "react-router-dom";
import BAFStakingTable from "./baf-staking-table";
import NftUnStakingTabs from "./nft-unstaking-tabs";

const StakingTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const stakingType = searchParams.get("staking_type");
  const [selectedKey, setSelectedKey] = useState("baf");

  useEffect(() => {
    if (stakingType === "nft") {
      setSelectedKey("nft");
    } else {
      setSelectedKey("baf");
    }
  }, [stakingType]);

  const handleTabChange = (key) => {
    setSelectedKey(key);
    searchParams.set("tab", "staking"); // ensure main tab stays 'staking'
    searchParams.set("staking_type", key); // update staking type param
    setSearchParams(searchParams);
  };

  return (
    <Tabs
      aria-label="Staking Options"
      selectedKey={selectedKey}
      onSelectionChange={handleTabChange}
      classNames={{
        tabList: "bg-[#E7E7E7]",
        cursor: "bg-yellowbuy border border-black"
      }}
    >
      <Tab key="baf" title="BAF">
        <BAFStakingTable />
      </Tab>
      <Tab key="nft" title="NFT">
        <div className="w-full border border-[#C2C2C2] px-4 lg:px-8 py-6 rounded-xl">
          <NftUnStakingTabs />
        </div>
      </Tab>
    </Tabs>
  );
};

export default StakingTabs;
